import { render } from "./pageCourse.vue?vue&type=template&id=9289b8b6&scoped=true"
import script from "./pageCourse.vue?vue&type=script&lang=js"
export * from "./pageCourse.vue?vue&type=script&lang=js"

import "./pageCourse.vue?vue&type=style&index=0&id=9289b8b6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9289b8b6"]])

export default __exports__